import { cva } from "class-variance-authority";

export const rootCva = cva(["relative w-full"]);

export const inputCva = cva([
  "flex h-10 w-full border px-3 py-2 text-sm disabled:opacity-50 transition-all duration-100 rounded-lg placeholder:text-base",
]);

export const leftIconCva = cva([
  "absolute left-3 top-1/2 transform -translate-y-1/2",
]);
export const rightIconCva = cva([
  "absolute right-3 top-1/2 transform -translate-y-1/2",
]);
